// Status-count aggregation — copied from statusTrackerUtil.createStatusAvatarList, but returns
// the [[status, count]] list directly (single pass) instead of calling a setter.

export const computeStatusCounts = (cells, statuses) => {
    const statusIdCntMap = new Map();

    Object.values(cells).forEach((cell) => {
        const dpStatusId = cell?.status?.status_id || cell?.status?.id || null;
        if (dpStatusId) {
            statusIdCntMap.set(dpStatusId, (statusIdCntMap.get(dpStatusId) ?? 0) + 1);
        }
    });

    // sort desc by count (same ordering as v1)
    const sortedMap = new Map([...statusIdCntMap.entries()].sort((a, b) => b[1] - a[1]));
    if (sortedMap.size === 0) return [];

    const statusCntList = [];
    for (const [statusId, statusCnt] of sortedMap) {
        const status = statuses.find((s) => s.id === statusId || s.status_id === statusId);
        if (status && statusCnt > 0) {
            statusCntList.push([status, statusCnt]);
        }
    }
    return statusCntList;
};
